import { Grid } from '@mui/material';
import FormTextInput from 'common/FormTextInput';

export default function Education({
    count,
    formData,
    handleChange,
    extraEducationInstitute,
    extraEducationDegree,
    extraEducationField,
}) {
    return (
        <div className={'w-full pl-3 mt-3'}>
            {/* Institution - Full width */}
            <FormTextInput
                name="education_institute"
                value={extraEducationInstitute?.[count]}
                handleChange={handleChange}
                placeholder="Enter institution's name"
                required={false}
                labelSize={0}
                textSize={12}
                noLabel={true}
                style={{ marginBottom: '16px' }}
                inputProps={{ autoComplete: 'off' }}
            />

            {/* Field of study and Degree - Side by side */}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormTextInput
                        name="education_field"
                        value={extraEducationField?.[count]}
                        handleChange={handleChange}
                        placeholder="Enter field of study"
                        required={false}
                        labelSize={0}
                        textSize={12}
                        noLabel={true}
                        disabled={false}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormTextInput
                        name="education_degree"
                        value={extraEducationDegree?.[count]}
                        handleChange={handleChange}
                        placeholder="Enter degree"
                        required={false}
                        labelSize={0}
                        textSize={12}
                        noLabel={true}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
